import api from '../../../services/Api';
import { IAuditoriaFornecedoresConciliacaoResultado } from '../interfaces/IAuditoriaFornecedoresConciliacao';

export const AuditoriaFornecedoresConciliacaoService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaFornecedoresConciliacaoResultado> {
    const response = await api.get<IAuditoriaFornecedoresConciliacaoResultado>('auditoria-fornecedores-conciliacao/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoClassificacaoReferencial: '',
        fornecedoresPendentesClassificacao: [],
        fornecedoresConciliados: [],
      }
    );
  },
};
